





































import { Component, Vue } from 'vue-property-decorator';
import { validationMixin } from 'vuelidate';
import { required, minLength, numeric, alpha, maxLength } from 'vuelidate/lib/validators';
import { CommonUtils } from '@/util/commonUtils';
import { EventBus } from '@/main';
import { MedTransGoConstants } from '@/util/constants';
import { ToastEvent } from '@/types/event';
import { ApiRequest, VerifyPaymentSourceRequest } from '@/types/request';
import { ObjectFactory } from '@/config/objectFactory';

@Component({
  props: {
    show: Boolean,
    customerId: String,
    paymentSource: String,
  },
  mixins: [validationMixin],
  data() {
    return {
      firstAmount: '',
      secondAmount: '',
    };
  },
  validations: {
    firstAmount: {
      required,
      numeric,
    },
    secondAmount: {
      required,
      numeric,
    },
  },
})
export default class VerifyACHCardModal extends Vue {
    private async verifyPaymentSource() {
        const verifyPaymentSourceRequest: VerifyPaymentSourceRequest = {
            amount: {
                firstAmount: this.$data.firstAmount,
                secondAmount: this.$data.secondAmount,
            },
            customerId: this.$props.customerId,
            paymentSourceId: this.$props.paymentSource,
        };
        const response = await ObjectFactory.getPaymentSourceService().verifyPaymentSource(this.$store.state.serverUrl,
        verifyPaymentSourceRequest);
        if (response.success) {
            this.$data.firstAmount = '';
            this.$data.secondAmount = '';
            this.$emit('close');
            this.$emit('success');
            const toastEvent: ToastEvent = {
                message: CommonUtils.translateMessageCode('MSG_VERIFY_ACH_ACCOUNT'),
                title: 'Success',
                varient: 'success',
                timeout: 2000,
            };
            EventBus.$emit(MedTransGoConstants.EVENT_SHOW_TOAST, toastEvent);
        } else {
            const toastEvent: ToastEvent = {
                message: CommonUtils.translateErrorCode('VALID_AMOUNT'),
                title: 'Fail',
                varient: 'danger',
                timeout: 2000,
            };
            EventBus.$emit(MedTransGoConstants.EVENT_SHOW_TOAST, toastEvent);
            CommonUtils.showError(response);
        }
    }

    private close() {
      this.$emit('close');
    }
}
